import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Product, ProductBase} from '../models/product.model';
import {DictionaryItem} from '../models/dictionary.model';
import {ProductPg} from '../models/product-pg.model';
import {PolicyTemplateListItem} from '../models/policy.model';

@Injectable()
export class ProductPgService {
    baseUrl = '/api/secured/product/pg';

    constructor(
        private http: HttpClient,
    ) {
    }

    getOne(id: number) {
        return this.http.get<Product>(`${this.baseUrl}/${id}`);
    }

    add(data: ProductBase) {
        return this.http.post<Product>(this.baseUrl, {...data});
    }

    duplicate(id: number, data: ProductBase) {
        return this.http.post<Product>(`${this.baseUrl}/${id}/duplicate`, {...data});
    }

    update(product: ProductPg) {
        return this.http.put(`${this.baseUrl}/${product.id}`, {...product});
    }

    merge(product: ProductPg) {
        return this.http.put(`${this.baseUrl}/${product.id}/merge`,
            {
                hash: product.configuration.configurationFile.hash,
                configurationNote: product.configuration.configurationNote
            });
    }

    uploadFile(hash) {
        return this.http
            .post(`${this.baseUrl}/import?hash=${hash}`, {});
    }

    downloadFile(hash) {
        window.location.href = `${this.baseUrl}/download?hash=${hash}`;
    }

    getTemplates() {
        return this.http.get<PolicyTemplateListItem[]>(`${this.baseUrl}/templates`);
    }

    getStatuses(id: number) {
        return this.http.get<DictionaryItem[]>(`${this.baseUrl}/${id}/statuses`);
    }
}
